import React, { MouseEvent, MouseEventHandler } from 'react';
import styled from 'styled-components';

import ClickOutside from '../ClickOutside';
import { ContactsButton, ContactsButtonSecondary } from '../styled/ContactsButton';

interface Props {
  onClose: () => void;
  doDelete: MouseEventHandler<HTMLButtonElement>;
  cancelDelete: MouseEventHandler<HTMLButtonElement>;
}

export default function DeletePopup(props: Props) {
  const onClick = (event: MouseEvent) => {
    event.stopPropagation();
  };

  return (
    <DeletePopupBoxWrapper onClick={onClick}>
      <ClickOutside onClickOutside={props.onClose}>
        <DeletePopupBox>
          <div className="mb-2 text-center">Are you sure you want to delete this contact?</div>
          <div className="mx-auto text-center">
            <ContactsButton hover={true} onClick={props.doDelete}>
              Yes
            </ContactsButton>
            <ContactsButtonSecondary onClick={props.cancelDelete}>
              No
            </ContactsButtonSecondary>
          </div>
        </DeletePopupBox>
      </ClickOutside>
    </DeletePopupBoxWrapper>
  );
}

const DeletePopupBoxWrapper = styled.div`
  position: relative;
`;

const DeletePopupBox = styled.div`
  width: 330px;
  height: 105px;
  background-color: #fff;
  position: absolute;
  top: 0;
  right: 0;
  padding: 16px;
  border-radius: 4px;
  box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.16);
  font-size: 14px;
  font-weight: bold;
  z-index: 1;
`;
